export default __webpack_public_path__ + "static/media/coverletter.7ef3ab4f.svg";